import { getImportFileCodeMessage, ImportFileCode } from './contactTracingImportCode.ts';

// The codes POST /api/import-file/screening answers with instead of a message.
export type ScreeningImportCode =
  | 'SCREENING_IMPORT.SUCCESS'
  | 'SCREENING_CASE_ID.REQUIRED'
  | 'SCREENING_CASE_ID.INVALID'
  | 'SCREENING_CASE_ID.NOT_FOUND'
  | ImportFileCode
  | 'SCREENING_IMPORT.INTERNAL_ERROR';

export function getScreeningImportMessage(code: string | undefined): string {
  switch (code) {
    case 'SCREENING_IMPORT.SUCCESS':
      return 'Die Datei wurde erfolgreich hochgeladen';
    case 'SCREENING_CASE_ID.REQUIRED':
      return 'Screening-Auftrag muss angegeben werden';
    case 'SCREENING_CASE_ID.INVALID':
      return 'Die ID des Screening-Auftrags ist ungültig';
    case 'SCREENING_CASE_ID.NOT_FOUND':
      return 'Der Screening-Auftrag wurde nicht gefunden';
    case 'SCREENING_IMPORT.INTERNAL_ERROR':
      return 'Die Datei konnte nicht verarbeitet werden. Bitte später erneut versuchen.';
    default:
      return getImportFileCodeMessage(code);
  }
}
